// IDs Discord autorises a VOIR le mode "mashup" et a CREER des rooms avec.
// N'importe qui invite (avec le lien) peut jouer, whiteliste ou non.
// Doit rester synchro avec ChatchoqServer/gameLogic.js (MASHUP_WHITELIST).
export const MASHUP_WHITELIST = [
  '275708705738194944', // owner
  '284374473317285889',
  '231859746263662593',
  '393865807140225035',
  '342736898852257793',
  '381451486695260173',
  '279115685458870272',
  '239380852876771330',
];

export function isMashupAllowed(userId) {
  return !!userId && MASHUP_WHITELIST.includes(String(userId));
}

export const OWNER_ID = '275708705738194944';

// Typologie d'un utilisateur : 'owner' | 'admin' (whiteliste) | 'player'.
export function typologyOf(userId) {
  const id = String(userId || '');
  if (id === OWNER_ID) return 'owner';
  if (MASHUP_WHITELIST.includes(id)) return 'admin';
  return 'player';
}
